import "./Privacy.scss";
import { Content } from "antd/es/layout/layout";
import { theme } from "antd";
import {
  SafetyOutlined,
  LockOutlined,
  EyeOutlined,
  UserOutlined,
  GlobalOutlined,
  FileProtectOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import {
  HeroCard,
  FeatureCard,
  BenefitsCard,
  ContactUs,
} from "../../components";

export default function Privacy() {
  const { useToken } = theme;
  const { token } = useToken();

  const heroData = {
    icon: <SafetyOutlined style={{ color: "#fff", fontSize: 40 }} />,
    title: "Privacy Policy",
    badge: "Currently in Effect",
    description:
      "At BlackList420, protecting your privacy isn't just a policy—it's our commitment. We employ industry-leading security measures and transparent practices to safeguard your personal and healthcare information. This policy details how we collect, use, and protect your data across our platform.",
  };

  const features = [
    {
      icon: <SafetyOutlined />,
      title: "Data Protection",
      description:
        "Advanced encryption and security protocols protect your sensitive information",
    },
    {
      icon: <LockOutlined />,
      title: "Secure Storage",
      description:
        "Enterprise-grade infrastructure with redundant backups and failover systems",
    },
    {
      icon: <EyeOutlined />,
      title: "Transparency",
      description:
        "Open communication about data practices with full disclosure",
    },
    {
      icon: <CheckCircleOutlined />,
      title: "Compliance",
      description:
        "HIPAA, GDPR, and international healthcare regulation compliance",
    },
  ];

  const sections = [
    {
      icon: <UserOutlined />,
      title: "Information We Collect",
      content: [
        "Account information including name, email, and organizational details",
        "Patient records and healthcare data you input or manage through our platform",
        "Usage data and interaction patterns to improve our services",
        "Authentication credentials and session information for security purposes",
      ],
    },
    {
      icon: <GlobalOutlined />,
      title: "How We Use Your Information",
      content: [
        "Provide and maintain our patient management services",
        "Ensure security and prevent fraudulent activity",
        "Improve and personalize your experience on our platform",
        "Communicate important updates, security alerts, and service information",
        "Comply with legal obligations and healthcare regulations",
      ],
    },
    {
      icon: <FileProtectOutlined />,
      title: "Data Sharing & Disclosure",
      content: [
        "We never sell your personal or patient data to third parties",
        "Data is only shared when required by law or healthcare regulations",
        "Service providers who assist our operations are bound by strict confidentiality agreements",
        "You maintain full control over your data and can request deletion at any time",
      ],
    },
    {
      icon: <LockOutlined />,
      title: "Your Rights & Choices",
      content: [
        "Access and review your personal information at any time",
        "Request corrections or updates to your data",
        "Delete your account and associated data",
        "Opt-out of non-essential communications",
        "Export your data in a portable format",
      ],
    },
  ];

  return (
    <Content className="privacy-cont">
      {/* Hero Section */}
      <HeroCard token={token} {...heroData} />

      {/* Privacy Features Grid */}
      <div className="privacy-cont__features">
        {features?.map((feature, index) => (
          <FeatureCard
            key={index}
            feature={feature}
            index={index}
            token={token}
          />
        ))}
      </div>

      {/* Main Content Section */}
      <div className="privacy-cont__mainContent">
        {sections.map((section, index) => (
          <BenefitsCard
            key={index}
            title={section?.title}
            icon={section?.icon}
            impactPoints={section?.content?.map((text) => ({
              icon: (
                <CheckCircleOutlined
                  style={{
                    color:
                      index % 2 === 0
                        ? token?.colorPrimary
                        : token?.colorSecondaryLogo,
                  }}
                />
              ),
              text,
            }))}
            token={token}
            borderColor={
              index % 2 === 0 ? token?.colorPrimary : token?.colorSecondaryLogo
            }
          />
        ))}
      </div>

      <ContactUs token={token} />
    </Content>
  );
}
